import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MeetingsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Meetings",
    children: /*#__PURE__*/_jsx("path", {
      d: "M25.11 5.81H22.7l-.01-2.4c0-.8-.66-1.44-1.45-1.44-.8 0-1.44.66-1.44 1.45v2.41l-7.7.04V3.46c-.02-.8-.67-1.44-1.47-1.44s-1.44.66-1.44 1.45v2.41l-2.4.01a3.38 3.38 0 0 0-3.35 3.39l.1 17.39a3.38 3.38 0 0 0 3.39 3.36l13.49-.08c.39 0 .75-.17 1-.43l6.71-6.79c.26-.26.41-.61.42-1.01l-.07-12.59a3.376 3.376 0 0 0-3.37-3.36ZM6.9 27.12a.47.47 0 0 1-.47-.44s-.07-13.06-.07-13.06l19.27-.11.04 7.6-.12.12-3.73.02c-1.06 0-1.92.87-1.92 1.94l.02 3.74-.12.12zm4.28-11.59H9.25c-.55.01-1 .47-1 1.02l.04 7.72c0 .55.46 1 1.01 1h1.93c.55-.01 1-.47 1-1.02l-.04-7.76a1.01 1.01 0 0 0-1.01-.96m5.83-.03H15c-.55.01-1 .47-1 1.02l.04 7.72c0 .55.46 1 1.01 1h2.01c.55-.01 1-.47 1-1.02l-.04-7.76a1.01 1.01 0 0 0-1.01-.96m3.82-.02h1.93c.53-.01.97.42.97.95v1.93c.01.53-.42.97-.95.97h-1.93a.954.954 0 0 1-.97-.95v-1.93c-.01-.53.42-.97.95-.97"
    })
  }));
};